import { OrderType, QuestionImportType } from '@exam-management/graphql';

export const initialQContentList = {
  category: '',
  chapter: '',
  field: 'refCode',
  group: '',
  page: 0,
  pageSize: 10,
  part: '',
  qIds: [],
  sort: OrderType.Desc,
  status: '',
  subject: '',
  subtopic: '',
  topic: '',
  type: [],
};

export enum QuestionCategoryInput {
  SINGLE_AND_LOQ = 'SINGLE_AND_LOQ',
  ITEM_SET = 'ITEM_SET',
}

export const QUESTION_IMPORT_TYPE_OPTIONS = [
  {
    label: 'Single & LOQ',
    value: QuestionImportType.SingleAndLoq,
  },
  {
    label: 'Item Set',
    value: QuestionImportType.ItemSet,
  },
];

export { QuestionImportType };
